import 'dayjs/locale/zh-cn'
import 'dayjs/locale/en'
import 'dayjs/locale/id'
import zhCN from '@arco-design/web-react/lib/locale/zh-CN'
import enUS from '@arco-design/web-react/lib/locale/en-US'
import idID from '@arco-design/web-react/lib/locale/id-ID'
import thTH from '@arco-design/web-react/lib/locale/th-TH'
import msMY from '@arco-design/web-react/lib/locale/ms-MY'
import esES from '@arco-design/web-react/lib/locale/es-ES'
import viVN from '@arco-design/web-react/lib/locale/vi-VN'
import { useSelector } from 'react-redux'
import { StoreState } from '@/store'
import { Language } from '@/utils/language'

const useI18n = () => {
  const { lang } = useSelector((state: StoreState) => state.ssr)
  const i18nMap = {
    [Language.zhCN]: { arco: zhCN, dayjs: 'zh-cn' },
    [Language.enUS]: { arco: enUS, dayjs: 'en' },
    [Language.idID]: { arco: idID, dayjs: 'id' },
    [Language.thTH]: { arco: thTH, dayjs: 'th' },
    [Language.msMY]: { arco: msMY, dayjs: 'ms' },
    [Language.esES]: { arco: esES, dayjs: 'es' },
    [Language.viVN]: { arco: viVN, dayjs: 'vi' }
  }

  return i18nMap[lang]
}

export default useI18n
